import { newGuid } from "./utility/guid";

const getOrCreateGuid = () => {
    try {
        let id = localStorage.getItem('GUEST_USER_ID');
        if (!id) {
            id = newGuid();
            localStorage.setItem('GUEST_USER_ID', id);
        }
        return id;
    }
    catch {
        return newGuid();
    }
};

export const GUEST_USER_ID = getOrCreateGuid();

export const eventTypes = [
    {
        id: 'watercooler',
        name: 'Water Cooler',
        description: 'Group around our virtual watercooler for some casual chats.',
        instructions: [
            'Introduce yourself',
            'Stay friendly'
        ],
        maxParticipants: 6,
        hideFromNavigation: false
    },
    {
        id: 'lunch-roulette',
        name: 'Lunch Roulette',
        description: 'Have your lunch ready and join someone else for lunch.',
        instructions: [
            'Get your lunch ready',
            'Introduce yourself',
            'Use an icebreaker: "What are you working on?"'
        ],
        maxParticipants: 2,
        hideFromNavigation: false
    },
    {
        id: 'focus-mate',
        name: 'Focus Mate',
        description: 'Stop procrastinating and pair with another do-er. Each work on their own stuff but hold the other accountable.',
        instructions: [
            'Briefly introduce yourself',
            'Agree on session duration (Default: 45min)', 
            'State what you will be working on',
            'Work'
        ],
        maxParticipants: 2,
        hideFromNavigation: false
    },
    {
        id: 'mastermind-group',
        name: 'Mastermind Group',
        description: 'Specifically designed for entrepreneurs. Discuss challenges you have in your business and help others overcome theirs.',
        instructions: [
            'Get everyone to introduce themselves', 
            'Dedicate 15min to each person', 
            'Try to offer advice on their most pressing challenge'
        ],
        maxParticipants: 4,
        hideFromNavigation: false
    },
    {
        id: 'meeting',
        name: 'Meeting',
        description: 'Video room associated with Meeting Wise.',
        maxParticipants: 99,
        instructions: [],
        hideFromNavigation: true        
    }
];

